import {Animation, AnimationComponent, Component, property} from '@wonderlandengine/api';

/**
 * Small helper component to retarget an animation on start.
 * This is needed when objects are instantiated from a prefab at runtime.
 */
export class RetargetAnimationOnStart extends Component {
    static TypeName = 'retarget-animation-on-start';

    @property.animation()
    animation?: Animation;

    start() {
        const aniComp = this.object.getComponent(AnimationComponent);
        if (aniComp) {
            aniComp.animation = this.animation.retarget([this.object, this.object]);
            aniComp.play();
        }
    }
}
